import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import Home from "./pages/Home"
import About from "./pages/About"
import Approvals from "./pages/adminview"
import PendingAccount from "./pages/PendingAccount"
import Login from "./pages/login"

import ActiveUsers from "./pages/active"
import Medicine from "./pages/medicine"
import Settings from "./pages/Settings"
import ContentManagement from "./pages/ContentManagement"
import Analytics from "./pages/Analytics"
import AllProducts from "./pages/AllProducts"
import ProductDetails from "./pages/ProductDetails"
import AllMedicine from "./pages/allMedicine"

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />

        <Route path="/Home" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/approvals" element={<Approvals />} />
        <Route path="/pending-account/:userId" element={<PendingAccount />} />
        <Route path="/analytics" element={<Analytics />} />
        <Route path="/active" element={<ActiveUsers />} />
        <Route path="/medicine/:userId" element={<Medicine />} />
        <Route path="/content-management" element={<ContentManagement />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/AllProducts" element={<AllProducts />} />
        <Route path="/product/:productId" element={<ProductDetails />} />
        <Route path="/allMedicine" element={<AllMedicine />} />
      </Routes>
    </Router>
  )
}

export default App
